<template>
  <path
    d="M16.85 6.85024L18.29 8.29024L13.41 13.1702L10.12 9.88024C9.72998 9.49024 9.09998 9.49024 8.70998 9.88024L2.70998 15.8902C2.31998 16.2802 2.31998 16.9102 2.70998 17.3002C3.09998 17.6902 3.72998 17.6902 4.11998 17.3002L9.40998 12.0002L12.7 15.2902C13.09 15.6802 13.72 15.6802 14.11 15.2902L19.7 9.71024L21.14 11.1502C21.45 11.4602 21.99 11.2402 21.99 10.8002V6.50024C22 6.22024 21.78 6.00024 21.5 6.00024H17.21C16.76 6.00024 16.54 6.54024 16.85 6.85024Z"
  />
</template>
